import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { exists } from '@utils/functions.js'

export const initialState = {}

export const category = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_CATEGORIES, (state, action) => receiveCategories(state, action))
})

function receiveCategories(state, action) {
  const { payload: categories } = action
  if (exists(categories)) {
    return {
      ...state,
      ...categories,
    }
  }
  return state
}

export default category
